<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">
                <section class="mcc-col mu-d-flex mu-flex-row mu-align-items-center">
                    <h1 class="mu-mb-00">External systems</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">
                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/new'">
                            <button class="mcc-button mcc-button--primary" id="addExternalSystemBtn" title="Add external system">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Add external system</span>
                            </button>
                        </router-link>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>Integrate</li>
                <li>External systems</li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div class="mcc-card__body">
                <Drawer ref="customFilter"  @reset-filter="resetFilter" @apply-filter="submitDialog" title="External System Filters">
                        <div class="mcc-row">
                            <form id="formIdd">
                            <div>
                                <div class="mfc-input-wrapper mfc-input-wrapper-sm mfc-form-input-container">
                                    <label for="name" class="mu-mb-00   ">Name</label>
                                    <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="externalSystemNameRef" @change="externalSystemNameRef = $event.target.value" />
                                </div>
                            </div>
                        </form>
                        </div>
                </Drawer>

                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <div >
                                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                    <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{externalSystemNameRef ? ' (1)' : ''}}</span>
                                    </button>
                                </div>
                                <mcc-data-table ref="externalSystemTable" id="externalSystemTableId"></mcc-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import Drawer from '../../common/Drawer.vue';
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "ExternalSystemList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["externalsystems.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            updateDialog: false,
            externalSystemName: "",
            externalSystemNameRef: "",
            tableData: [],
            filterList: [],
            filterActive: false,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.initExternalSystemTable();
        if (localStorage.getItem("externalSystemList") === "externalSystemList") {

            let storedESName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_externalSystemName"
            );
            if (storedESName != null && storedESName != "") {
                this.externalSystemNameRef = storedESName;
                this.externalSystemName = storedESName;
            }
            let storedSize = localStorage.getItem("ExternalSystemListPageSize");
            if (storedSize != null && storedSize != "") {
                this.currentPageSize = parseInt(storedSize);
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_externalSystemName"
            );
            localStorage.removeItem("ExternalSystemListPageSize");
            localStorage.removeItem("externalSystemList");
        }
    },
    methods: {
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        updateExternalSystemList(filteredList) {
            this.filterList = filteredList;
            this.filterActive = true;
            this.initExternalSystemTable();

        },
        resetFilter() {
            this.updateCall = false;
            this.externalSystemNameRef = "";
            this.externalSystemName = "";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initExternalSystemTable();
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.externalSystemName = this.externalSystemNameRef;
            this.initExternalSystemTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        updateTemplate() {
            let self = this;
            if (self.tableObj != null) {
                self.currentPageSize = self.tableObj.tableContext.store.state.pageSize;
            }
            this.$refs.externalSystemTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/integrate/externalsystems/" + reference.trim()
                            );
                        }
                    });
                });
        },
        initExternalSystemTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("externalSystemTableId"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No external systems found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                emptyStatusRecords: {
                    icon: 'empty_folder',
                    title: 'No external systems found',
                },
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            columnSearch: false
                        },
                        description: {
                            type: "string",
                            title: "Description",
                            sortable: true,
                            columnSearch: false
                        },
                        requireUserMapping: {
                            type: "string",
                            title: "Requires user mapping ?",
                            sortable: false,
                            columnSearch: false
                        },
                        supportHierarchy: {
                            type: "string",
                            title: "Supports hierarchy import ?",
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }

                        let queryString =
                            "name=" +
                            self.externalSystemName +
                            "&start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection
                        return ExternalSystemAPI.getExternalSystems(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                                self.tableData = result.data;
                            }
                            self.updateCall = true;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterList.length,
                            data: self.filterList
                        };
                        return responseData;
                    }
                },
                onPageChange: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("ExternalSystemListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_externalSystemName",
                this.externalSystemName
            );
        }
    }
};
</script>

<style scoped></style>
